"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var safeInternalPath_1 = require("./safeInternalPath");
var playerSelection_1 = require("../caroline/playback/playerSelection");
var toPath = function (link) { var _a; return (_a = (0, safeInternalPath_1.safeInternalPath)((0, playerSelection_1.preparePlayerNavigation)(link).replace(/^#/, ''))) !== null && _a !== void 0 ? _a : '/'; };
exports.default = toPath;
